<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Create Linked Planograms</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <p class="text-muted">
    Create linked (view-only) planograms of <strong>{{ planogram.merchName }}</strong> for one or more stores.
    Each one always shows this planogram's layout and can be exported under its own store's details,
    but cannot be edited.
  </p>

  <div class="mb-3">
    <label class="form-label">Add stores</label>
    <input type="text" class="form-control" placeholder="Search stores..."
           [(ngModel)]="storeModel"
           [ngbTypeahead]="searchStores"
           [resultFormatter]="storeFormatter"
           [inputFormatter]="storeFormatter"
           (selectItem)="onStoreSelect($event)" />
    <small class="text-muted">Only stores from the same data source as this planogram can be linked.</small>
  </div>

  <div class="mb-3" *ngIf="selectedStores.length > 0">
    <label class="form-label">Selected stores ({{ selectedStores.length }})</label>
    <div class="d-flex flex-wrap gap-2">
      <span class="badge bg-secondary d-flex align-items-center gap-1" *ngFor="let store of selectedStores">
        {{ store.name }}
        <button type="button" class="btn-close btn-close-white" style="font-size: 0.6rem;"
                aria-label="Remove" (click)="removeStore(store)"></button>
      </span>
    </div>
  </div>

  <div class="mb-3">
    <label class="form-label">Destination folder</label>
    <select class="form-select" [(ngModel)]="folderId">
      <option value="">Default folder</option>
      <option *ngFor="let f of flatFolders" [value]="f.id">{{ f.name }}</option>
    </select>
  </div>

  <div class="form-check">
    <input type="checkbox" class="form-check-input" id="useStoreSales" [(ngModel)]="useStoreSales" />
    <label class="form-check-label" for="useStoreSales">Use store sales</label>
    <small class="d-block text-muted">
      When on, each linked planogram shows its own store's sales, DOS and CPI. When off, it shows this
      planogram's sales instead.
    </small>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary"
          [disabled]="selectedStores.length === 0 || isSubmitting"
          (click)="submit()">
    Create {{ selectedStores.length || '' }} Linked Planogram{{ selectedStores.length === 1 ? '' : 's' }}
  </button>
</div>
